import { render, staticRenderFns } from "./AnalysesMetaH1Subtitle.vue?vue&type=template&id=53258d9c&"
import script from "./AnalysesMetaH1Subtitle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesMetaH1Subtitle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53258d9c')) {
      api.createRecord('53258d9c', component.options)
    } else {
      api.reload('53258d9c', component.options)
    }
    module.hot.accept("./AnalysesMetaH1Subtitle.vue?vue&type=template&id=53258d9c&", function () {
      api.rerender('53258d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesMetaH1Subtitle.vue"
export default component.exports